import { existsMultiLanguage } from './existsMultiLanguage';

/**
 * @description 各施設、多言語サブディレクトリの階層取得
 * @description 施設はルート以下（/atami/）、多言語は各言語dir以下（/en/atami/）想定.
 */
export const getEachSiteRouteLayers = () => {
  const layerList = location.pathname.split('/');

  return existsMultiLanguage() ? layerList[1] + '/' + layerList[2] : layerList[1];
};
